import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreTo, moreLabel = '查看全部' }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-start gap-3">
        <span className="w-10 h-10 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
          <i className={`${icon} text-xl`}></i>
        </span>
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-sm font-label text-foreground-600">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm font-label text-primary-600 hover:text-primary-700 whitespace-nowrap transition-colors"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      )}
    </div>
  );
}